import type { FC } from 'react'
import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import StartWithStrategyImage from './StartWithStrategyImage'

const copy = {
  heading: `Start with strategy`,
  description: `Optimize your customer data architecture with validated designs and actionable recommendations rooted in thousands of implementations.`,
}

const StartWithStrategy: FC = () => (
  <Wrapper>
    <SectionBase variant="2Col">
      <SectionCopy>
        <CopyTextBase>
          <CopyText.Heading variant="h2" tag="h2">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pLarge" tag="p">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
      </SectionCopy>

      <Section.Contents>
        <StartWithStrategyImage />
      </Section.Contents>
    </SectionBase>
  </Wrapper>
)

const Wrapper = styled.div``

const SectionCopy = styled(Section.Copy)`
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 392px;
    justify-self: end;
    align-self: center;
  }
`

export default StartWithStrategy
